import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { setActiveAction} from '@process-advisor/process-miner/processMiner/processMiner'

export type Props = ApiMethodBase & {}

export const setAction_DecompositionTree = ({ eventEmitter }: Props) => {
    setActiveAction('decomposition_tree')
    eventEmitter.emit(Event.setActionBar_DecompositionTree, { findingID: null, source: 'decomposition_tree' });
    eventEmitter.emit(Event.setDiagramWidth, { findingID: null });
};
